import { type PaletteColor, createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    neutral: PaletteColor & { lighter: string };
    login: Palette['primary'];
    darkgray: Palette['primary'];
    yellow: Palette['primary'];
  }
  interface PaletteOptions {
    neutral: PaletteOptions['primary'] & { lighter: string };
    login: PaletteOptions['primary'];
    darkgray: PaletteOptions['primary'];
    yellow?: PaletteOptions['primary'];
  }
}

declare module '@mui/material/Chip' {
  interface ChipPropsColorOverrides {
    yellow: true;
  }
}

export const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1288,
      xl: 1536,
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  palette: {
    background: {
      default: '#F6F9FB',
    },
    primary: {
      main: '#009D63',
    },
    secondary: {
      main: '#F5F5F5',
    },
    neutral: {
      main: '#E0E1E2',
      dark: '#C8C8CA',
      light: '#DEDEDF',
      lighter: '#F3F4F5',
    },
    login: {
      dark: '#17141D',
      light: '#433E4B',
      main: '#17141D',
    },
    info: {
      main: '#2F5CD2',
      light: '#BAC9F1',
      dark: '#2F5CD2',
    },
    error: {
      main: '#E3615C',
    },
    darkgray: {
      main: '#DCDCDC',
    },
    yellow: {
      main: '#ffeb3b',
      contrastText: '#000',
    },
  },
  components: {
    MuiTabs: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid #DEDEDF',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          color: '#242424',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: '#F5F5F5',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          ...(ownerState.color === 'yellow' && {
            backgroundColor: theme.palette.yellow.main,
            color: theme.palette.yellow.contrastText,
          }),
        }),
      },
    },
    MuiTableRow: {
      defaultProps: {
        hover: true,
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: 'none',
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          userSelect: 'none',
        },
      },
    },
  },
});
